import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {
	return createStyles({
		administrationLinks_container: {
			padding: theme.spacing(1, 0),
		},
		administrationLinks_listItem: {

		},
		administrationLinks_listItemHeaderText: {
			color: theme.palette.grey[500],
		},
		administrationLinks_listItemSubHeaderText: {
			color: theme.palette.grey[500],
			padding: theme.spacing(0,0,0,1),
		},
		administrationLinks_listItemTextWrapper: {
			display: 'flex',
		},
		administrationLinks_listItemText: {
			fontSize: theme.typography.body2.fontSize,
			color: theme.palette.info.main,
			textDecoration: 'underline',
		},
		administrationLinks_listItemTextSelected: {
			fontSize: theme.typography.body2.fontSize,
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			textDecoration: 'underline',
		},
		administrationLinks_indentation: {
			paddingLeft: theme.spacing(2)
        },
		administrationLinks_divider: {
			backgroundColor: theme.palette.grey[400],
		}
	});
}

export default styles;